import { ReactElement } from 'react';
import { IconButton } from './IconButton';
import { DocumentIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { Tooltip } from 'react-tooltip';
import cs from 'classnames';
import { Loader } from './Loader';

interface Props {
  uuid: string;
  name: string;
  onDelete?: ({ uuid }: { uuid: string }) => void;
  classNames?: string;
  loading?: boolean;
}

export const FileCard = ({
  uuid,
  name,
  onDelete,
  classNames,
  loading,
}: Props): ReactElement => (
  <div
    className={cs(
      `flex items-center space-x-px border rounded-xs border-grey-t-600 group relative ${classNames}`,
      {
        'hover:border-grey-t-400': !!onDelete && !loading,
      }
    )}
    key={uuid}
  >
    <div className="px-2.5 py-2 flex items-center space-x-2">
      {loading ? (
        <Loader className="size-5 shrink-0" />
      ) : (
        <DocumentIcon className="size-5 text-text-low-priority" />
      )}
      {loading ? (
        <span className="w-20 h-3 rounded-xs bg-grey-t-700 animate-pulse" />
      ) : (
        <>
          <Tooltip
            id="1"
            content="Remove"
            openEvents={{ mouseover: true }}
            closeEvents={{
              click: true,
              mouseleave: true,
              blur: true,
            }}
            className="z-20"
            place="bottom"
          />
          <span className="text-text-low-priority text-sm truncate max-w-50">
            {name}
          </span>
        </>
      )}
    </div>
    {onDelete && !loading && (
      <IconButton
        Icon={XMarkIcon}
        type="basic"
        onClick={() =>
          onDelete({
            uuid,
          })
        }
      />
    )}
  </div>
);
